class Tabs {
  constructor (el) {
    this.el = el
    this.btn = this.el.querySelectorAll('.js-tabs-btn')
    this.content = this.el.querySelectorAll('.js-tabs-content')

    this.initDefaults()
  }

  initDefaults () {
    this.initDefaultState()
    this.initEvents()
  }

  initEvents () {
    $(this.btn).on('click', e => this.toggle(e))
  }

  toggle (e) {
    e.preventDefault()
    const $target = $(e.currentTarget)

    if ($target.hasClass('active')) return;

    const index = $target.attr('data-index')

    $(this.btn).removeClass('active')

    this.btn.forEach(el => {
      if (el.getAttribute('data-index') === index) {
        el.classList.add('active')
      }
    })

    $(this.content).fadeOut(300).promise().done(() => {
      $(this.content).eq(index).fadeIn(300)
    })
  }

  initDefaultState () {
    this.content.forEach(el => {
      el.classList.contains('active') ? el.style.display = 'block' : el.style.display = 'none'
    })
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.js-tabs')

  if (items.length) {
    items.forEach(el => {
      new Tabs(el)
    })
  }
})